export var BulkOperationStatus;
(function (BulkOperationStatus) {
    BulkOperationStatus["Unspecified"] = "unspecified";
    BulkOperationStatus["Requested"] = "requested";
    BulkOperationStatus["Processing"] = "processing";
    BulkOperationStatus["Success"] = "success";
    BulkOperationStatus["Error"] = "error";
})(BulkOperationStatus || (BulkOperationStatus = {}));
//# sourceMappingURL=BulkOperations.js.map